module.exports = __webpack_public_path__ + "static/media/porcobrar_black.4950a673.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo/porcobrar_black.png
// module id = 554
// module chunks = 36